import { ErrorCodes } from '../../error/ErrorCodes';
import RetryUtil from './RetryUtil';

export default class AsyncUtil {
  public static async retryOnNetworkFailure<T>(
    callback: () => Promise<T>,
    retryCount?: number | undefined,
  ): Promise<T> {
    return RetryUtil.retry(callback, retryCount, undefined, (err: any) => {
      if (err && err.doesBelongToCategory != undefined) {
        return err.doesBelongToCategory(ErrorCodes.ERROR_CATEGORY_MASK_NETWORK);
      }
      return false;
    });
  }
}
